import React from 'react';
import { ChevronDown, Flame, ChevronRight, Tag, MoreHorizontal } from 'lucide-react';
 
 export default function SubNavbar({ categories = [], onSelectCategory }) {

  // Lọc ra các danh mục gốc (không có parentId) và loại trừ mục 'all' nếu có sẵn trong mảng
  const parentCategories = Array.isArray(categories) 
  ? categories.filter(cat => {
      const pid = cat.parentId;
      const hasNoParentId = pid === undefined || pid === null || pid === 0 || pid === '0' || pid === '';
      const hasNoParentObj = !cat.parent || !cat.parent.id;
      return hasNoParentId && hasNoParentObj && cat.id !== 'all';
    }) 
  : [];
 
  // Giới hạn số lượng danh mục cha hiển thị trực tiếp trên thanh menu (ví dụ: tối đa 6 mục)
  const MAX_VISIBLE = 5;
  const visibleParents = parentCategories.slice(0, MAX_VISIBLE);
  const overflowParents = parentCategories.slice(MAX_VISIBLE);
 
  // Hàm xử lý chọn danh mục
  const handleCategoryClick = (cat) => {
    const isAll = cat.id === 'all' || cat.name?.toLowerCase().includes('tất cả');
    const categoryParam = isAll ? 'all' : (cat.id || cat.name);
    const categoryName = isAll ? 'Tất Cả Sản Phẩm' : (cat.name || 'Danh mục');

    if (onSelectCategory) {
      onSelectCategory(categoryParam, categoryName);
    }

    // Tự động trôi mượt mà xuống phần sản phẩm
    const productsSection = document.getElementById('products-section');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
     }
   };
 
   return (

    <div className="bg-slate-50 border-b border-slate-200 text-xs font-semibold text-slate-700 hidden lg:block sticky top-20 z-30 w-full shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-11">
 
        {/* Khu vực danh mục */}
        <div className="flex items-center space-x-5 h-full py-1">
          
          {/* Nút Tất Cả Sản Phẩm luôn đặt ở đầu */}
          <div className="relative h-full flex items-center cursor-pointer group shrink-0">
            <button
              type="button"
              onClick={() => handleCategoryClick({ id: 'all', name: 'Tất Cả Sản Phẩm' })}
              className="flex items-center space-x-1 text-indigo-600 hover:text-indigo-700 font-bold transition py-2 text-xs whitespace-nowrap focus:outline-none h-full"
            >
              <span>Tất Cả Sản Phẩm</span>
            </button>
          </div>
 
          {/* Các danh mục cha chính (hiển thị tối đa 6 mục để giao diện thoáng) */}
          {visibleParents.map((cat, index) => {
            const subItems = Array.isArray(categories) 
              ? categories.filter(sub => Number(sub.parentId) === Number(cat.id))
              : [];
            
            return (
              <div
                key={`parent-${cat.id || index}`}
                className="relative h-full flex items-center cursor-pointer group shrink-0"
              >
                <button
                  type="button"
                  onClick={() => handleCategoryClick(cat)}
                  className="flex items-center space-x-1 text-slate-700 group-hover:text-indigo-600 transition py-2 text-xs font-semibold whitespace-nowrap focus:outline-none h-full"
                >
                  <span className="max-w-[110px] truncate">{cat.name}</span>
                  {subItems.length > 0 && (
                    <ChevronDown className="w-3.5 h-3.5 text-slate-400 group-hover:text-indigo-600 transition shrink-0" />
                   )}
                </button>

                {/* Dropdown danh mục con */}
                {subItems.length > 0 && (
                <div className="absolute top-full left-0 w-max min-w-[14rem] bg-white rounded-2xl shadow-xl border border-slate-100 p-3 space-y-1 z-50 text-left hidden group-hover:block pt-2">
                  {subItems.map((sub, idx) => (
                    <button
                      key={`sub-${sub.id || idx}`}
                      type="button"
                      onClick={() => handleCategoryClick(sub)}
                      className="w-full text-left block px-3 py-2 rounded-xl text-xs text-slate-600 hover:bg-slate-50 hover:text-indigo-600 font-medium transition whitespace-nowrap"
                    >
                      {sub.name}
                    </button>
                  ))}
                 </div>
              )}
              </div>
            );
          })}

          {/* Phần "Xem thêm" nếu số lượng danh mục cha vượt quá giới hạn MAX_VISIBLE */}
          {overflowParents.length > 0 && (
            <div className="relative h-full flex items-center cursor-pointer group shrink-0">
              <button
                type="button"
                className="flex items-center space-x-1 text-slate-600 hover:text-indigo-600 transition py-2 text-xs font-semibold whitespace-nowrap focus:outline-none h-full"
              >
                <span>Xem thêm</span>
                <MoreHorizontal className="w-4 h-4 text-slate-400 group-hover:text-indigo-600" />
              </button>
 
              {/* Box dropdown chính - Đã bỏ overflow-y-auto để không bị cắt box con bên cạnh */}
              <div className="absolute top-full left-0 w-64 bg-white rounded-2xl shadow-xl border border-slate-100 p-2 space-y-1 z-50 text-left hidden group-hover:block pt-2">
                {overflowParents.map((cat, idx) => {
                  const subItems = Array.isArray(categories) 
                    ? categories.filter(sub => Number(sub.parentId) === Number(cat.id))
                    : [];

                  return (
                    <div key={`overflow-${cat.id || idx}`} className="relative group/sub">
                      <button
                        type="button"
                        onClick={() => handleCategoryClick(cat)}
                        className="w-full text-left flex items-center justify-between px-3 py-2 rounded-xl text-xs text-slate-700 hover:bg-slate-50 hover:text-indigo-600 font-medium transition whitespace-nowrap"
                      >
                        <span className="truncate pr-2">{cat.name}</span>
                        {subItems.length > 0 && (
                          <ChevronRight className="w-3.5 h-3.5 text-slate-400 group-hover/sub:text-indigo-600 shrink-0" />
                        )}
                      </button>

                      {/* Box danh mục con bung ra thành khung riêng độc lập bên cạnh */}
                      {subItems.length > 0 && (
                        <div className="absolute left-full top-0 ml-2 w-56 bg-white rounded-2xl shadow-xl border border-slate-100 p-2 space-y-1 z-50 text-left hidden group-hover/sub:block max-h-80 overflow-y-auto">
                          {subItems.map((sub, sIdx) => (
                            <button
                              key={`sub-overflow-${sub.id || sIdx}`}
                              type="button"
                              onClick={() => handleCategoryClick(sub)}
                              className="w-full text-left block px-3 py-2 rounded-xl text-xs text-slate-600 hover:bg-slate-50 hover:text-indigo-600 font-medium transition whitespace-nowrap truncate"
                            >
                              {sub.name}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
        {/* Các nút phụ bên phải */}
        <div className="flex items-center space-x-6 whitespace-nowrap shrink-0">
          <button
            type="button"
            onClick={() => {
              const flashSaleSection = document.getElementById('flash-sale-section');
              if (flashSaleSection) {
                flashSaleSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
            className="flex items-center space-x-1.5 text-rose-600 hover:text-rose-700 font-bold transition focus:outline-none"
          >
            <Flame className="w-4 h-4" />
            <span>Flash Sale -50%</span>
          </button>
 
          <button
            type="button"
           onClick={() => {
              const flashSaleSection = document.getElementById('cupon-section');
              if (flashSaleSection) {
                flashSaleSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
            className="flex items-center space-x-1.5 text-amber-600 hover:text-amber-700 font-bold transition focus:outline-none"
          >
            <Tag className="w-4 h-4" />
            <span>Mã Giảm Giá</span>
          </button>
         </div>

       </div>
    </div>
   );
 }
